import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import DesktopNavbar from './nav/DesktopNavbar';
import MobileTopBar from './nav/MobileTopBar';
import BottomNav from './nav/BottomNav';
import SideMenu from './nav/SideMenu';
import SupportSheet from './SupportSheet';
import { Toast } from '../lib/ui/Feedback';

export default function AppShell() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState('');

  return (
    <div className="min-h-screen flex flex-col">
      <DesktopNavbar />
      <MobileTopBar onMenuClick={() => setMenuOpen(true)} />

      <main className="flex-1 pb-20 md:pb-10">
        <Outlet context={{ setToastMsg, setSupportOpen }} />
      </main>

      <footer className="hidden md:block text-center py-6 text-xs text-ink-faint">
        <a href="/privacy.html" target="_blank" rel="noreferrer" className="underline mr-4 hover:text-ink">Privacy Policy</a>
        <a href="/terms.html" target="_blank" rel="noreferrer" className="underline hover:text-ink">Terms &amp; Conditions</a>
        <div className="mt-1.5">© {new Date().getFullYear()} NRK Mart. All rights reserved.</div>
      </footer>

      <BottomNav />
      <SideMenu open={menuOpen} onClose={() => setMenuOpen(false)} onSupportOpen={() => setSupportOpen(true)} />
      <SupportSheet open={supportOpen} onClose={() => setSupportOpen(false)} />
      <Toast message={toastMsg} />

      <button
        type="button"
        onClick={() => setSupportOpen(true)}
        aria-label="Customer support"
        className="hidden md:flex fixed bottom-8 right-8 h-14 w-14 rounded-full bg-brand-dark text-white text-2xl items-center justify-center shadow-lift hover:bg-brand-deep z-40"
      >
        🆘
      </button>
    </div>
  );
}
